import { render } from "./MaterialSwitch.vue?vue&type=template&id=0acdada4&scoped=true"
import script from "./MaterialSwitch.vue?vue&type=script&lang=js"
export * from "./MaterialSwitch.vue?vue&type=script&lang=js"

import "./MaterialSwitch.vue?vue&type=style&index=0&id=0acdada4&scoped=true&lang=scss"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0acdada4"]])

export default __exports__